import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/Layout'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: '登录',
    //component: () => import(/* webpackChunkName: "page" */ '@/components/login_back'),
    component: () => import(/* webpackChunkName: "page" */ '@/components/login'),
    meta: {
      title: '保时捷培训护照',
      keepAlive: true,
      isTab: false,
      isAuth: false,
    },
  },
  {
    path: '/',
    name: 'index',
    redirect: '/login',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'Index',
        component: () => import('@/components/index'),
        meta: {
          title: '保时捷培训护照',
          showTab: true,
        },
      },
      {
        path: 'index',
        name: 'Index',
        component: () => import('@/components/index'),
        meta: {
          title: '保时捷培训护照',
          showTab: true,
        },
      },
      {
        path: 'dealerIndex',
        name: 'DealerIndex',
        component: () => import('@/components/dealerIndex'),
        meta: {
          title: '保时捷培训护照',
          showTab: true,
        },
      },
      {
        path: '/course/detail',
        name: 'CourseDetail',
        meta: {
          title: '保时捷培训护照',
          showTab: false,
        },
        component: () => import('@/components/courseDetail'),
      },
      {
        path: 'userIndex',
        name: 'UserIndex',
        component: () => import('@/components/userIndex'),
        meta: {
          title: '保时捷培训护照',
          showTab: false,
        },
      },
      {
        path: 'user/passport',
        name: 'Passport',
        meta: {
          title: '保时捷培训护照',
          showTab: true,
        },
        component: () => import('@/components/user/passport'),
      },
      {
        path: 'user/course',
        name: 'Course',
        meta: {
          title: '保时捷培训护照',
          showTab: true,
        },
        component: () => import('@/components/user/course'),
      },
      {
        path: 'user/userCenter',
        name: 'userCenter',
        meta: {
          title: '保时捷培训护照',
          showTab: true,
        },
        component: () => import('@/components/user/userCenter'),
      },
      // {
      //   path: 'dealerCenter',
      //   name: 'dealerCenter',
      //   meta: {
      //     title: '保时捷培训护照',
      //     showTab: true,
      //   },
      //   component: () => import('@/components/dealerCenter'),
      // },
    ],
  },
  {
    path: '/totalRank',
    name: 'TotalRank',
    component: () => import('@/components/rank/totalRank'),
    meta: {
      title: '保时捷培训护照',
      showTab: false,
    },
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/components/searchPage'),
    meta: {
      title: '保时捷培训护照',
      showTab: false,
    },
  },
  {
    path: '/historyList',
    name: 'HistoryList',
    component: () => import('@/components/user/historyList'),
    meta: {
      title: '保时捷培训护照',
      showTab: false,
    },
  },
  {
    path: '/historyCourseList',
    name: 'HistoryCourseList',
    component: () => import('@/components/user/historyCourseList'),
    meta: {
      title: '保时捷培训护照',
      showTab: false,
    },
  },
  {
    path: '/cdbList',
    name: 'CdbList',
    component: () => import('@/components/user/cdbList'),
    meta: {
      title: '保时捷培训护照',
      showTab: false,
    },
  },
  {
    path: '/notice',
    name: 'Notice',
    component: () => import('@/components/notice/list'),
    meta: {
      title: '保时捷培训护照',
      showTab: false,
    },
  },
  {
    path: '/notice/detail',
    name: 'NoticeDetail',
    component: () => import('@/components/notice/detail'),
    meta: {
      title: '保时捷培训护照',
      showTab: false,
    },
  },
  {
    path: '/feedback',
    name: 'Feedback',
    meta: {
      title: '保时捷培训护照',
      showTab: true,
    },
    component: () => import('@/components/user/feedback'),
  },
  {
    path: '/editPwd',
    name: 'EditPwd',
    meta: {
      title: '保时捷培训护照',
      showTab: true,
    },
    component: () => import('@/components/user/editPwd'),
  },
  {
    path: '/editNickNm',
    name: 'EditNickNm',
    meta: {
      title: '保时捷培训护照',
      showTab: true,
    },
    component: () => import('@/components/user/editNm'),
  },
]

const router = new VueRouter({
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
